require('../proposals/string-match-all');

module.exports = require('../internals/path');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/stage/4.js
// module id = tIY1
// module chunks = 2